import './Fees.css';

export const Fees = () => {
  return (
    <>
      <section className="snn-page-section">
        <h1 className="snn-title">Registration Fees</h1>
        <table className="snn-table-fees">
          <thead>
            <tr>
              <th></th>
              <th>Student</th>
              <th>
                Researcher/
                <br />
                Postdoc
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Early Bird, April 6 to April 30, 2026</td>
              <td className="snn-prices-cell">$800.00</td>
              <td className="snn-prices-cell">$1,600.00</td>
            </tr>
            <tr>
              <td>After April 30th, 2026</td>
              <td className="snn-prices-cell">$1,100.00</td>
              <td className="snn-prices-cell">$2,200.00</td>
            </tr>
          </tbody>
        </table>
        <p>Note: Registration Fees in Mexican pesos</p>
      </section>
      <section className="snn-page-section">
        <h1 className="snn-title">Fellowships</h1>
        <p>
          <strong>Attention students:</strong> All undergraduate, master&apos;s, and doctoral
          students whose abstracts have been accepted and are presenting them will be entitled to a
          scholarship. On April, the scholarship system will be available on our website.
          Remember, you will need current proof of your student status.
        </p>
      </section>
    </>
  );
};
